import '@babel/polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import './plugins/vuetify'
import multiFilters from  './plugins/multiFilters'
import App from './App.vue'
import {routes} from "./route";
import store from "./store";
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as lodash from "lodash";

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(lodash);
Vue.use(multiFilters);


Vue.config.productionTip = false;

export const GlobalEudoxusBus = new Vue();


const router = new VueRouter({
    routes
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
